import type * as React from 'react';
import { post } from '@Domain/Api';
import authenticationModesResolved, {
	type AuthenticationModesPayload,
	type AuthenticationModesResolvedAction,
} from '@Application/Security/Sso/Actions/authenticationModesResolved';
import authenticationModesResolutionFailed, {
	type AuthenticationModesResolutionFailedAction,
} from '@Application/Security/Sso/Actions/authenticationModesResolutionFailed';
import type ResolveAuthenticationModes from '@Application/Security/Sso/Commands/ResolveAuthenticationModes';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AuthenticationModesResolvedAction | AuthenticationModesResolutionFailedAction;

export default (command: ResolveAuthenticationModes) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<AuthenticationModesPayload>(
				`${parameters.api.host}/api/authentication-modes`,
				command.toJSON(),
				{ retryOnUnauthorized: false },
			);

			const action = authenticationModesResolved(payload, command.email);
			dispatch(action);
			return action;
		} catch (error) {
			const action = authenticationModesResolutionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
